export default __webpack_public_path__ + "static/media/card2-3.ea502aa1.svg";